import Slider from 'react-slick'
import {useEffect, useState} from 'react'
import {RootState} from '../../../../setup/redux/RootReducer'
import {useSelector} from 'react-redux'
import {PageTitle} from '../../../../_metronic/layout/core'
import {useHistory, useLocation} from 'react-router-dom'
import {useApolloClient} from '@apollo/client'
import {DocumentRelations, Product, ProductTag} from '../../../types'
import {GET_PRODUCT_DETAIL, GET_SETTING} from '../../../store/queries'
import {isMobile} from 'react-device-detect'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import './ProductDetail.css'

export default function ProductDetail() {
  let images: any = {}
  images['no'] =
    'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Logo_METRO.svg/1200px-Logo_METRO.svg.png'

  const [productModel, setProductModel] = useState<Product | undefined>()

  const productDetailImages = productModel?.documentRelations
    .filter((x) => x.rank != 0 && x.document.documentTypeCode == 'F')
    .sort((x: DocumentRelations, y: DocumentRelations) => (x.rank - y.rank > 1 ? 1 : 0))

  const productDetailDocuments = productModel?.documentRelations.filter(
    (x) => x.rank != 0 && x.document.documentTypeCode == 'D'
  )

  const productVideos = productModel?.documentRelations.filter(
    (x) => x.rank != 0 && x.document.documentTypeCode == 'V'
  )

  const settings = {
    customPaging: function (i: any) {
      return (
        <a>
          <img
            src={productDetailImages![i]?.document.fileName + '?w=400&h=400&mode=pad'}
            height='60'
            width='60'
          />
        </a>
      )
    },
    dots: true,
    dotsClass: 'slick-dots slick-thumb customDotClass',
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const pageLinks = useSelector((state: RootState) => state.pageLinkReducer)
  console.log("54 pageLinks => ",pageLinks);

  useEffect(() => {
    console.log('productModel =>> ', productModel)
  }, [productModel])

  const location = useLocation()
  const history = useHistory()
  const search = location.search
  let _productGuid = new URLSearchParams(search).get('guid')

  const client = useApolloClient()

  useEffect(() => {
    setProductModel(undefined)

    async function getList() {
      return await client
        .query({
          query: GET_PRODUCT_DETAIL,
          variables: {productGuid: _productGuid},
        })
        .then((resp) => {
          console.log('product model  => ', resp)
          if (resp.error) {
            return false
          } else {
            try {
              setProductModel(resp.data.products.edges[0].node)
            } catch (err) {
              console.log('burada => ', err)
            }
          }
        })
        .catch((err: any) => {
          console.log('error activity list => ', err)
          return false
        })
    }

    getList()
  }, [])

  const subStrFunc = (input: string, maxSize: number, addtionalText: string) => {
    if (input?.length > maxSize) {
      return input.substring(0, maxSize) + addtionalText
    }
    return input
  }

  return (
    <>
      <PageTitle breadcrumbs={pageLinks.PageLinkList}>{productModel?.displayName}</PageTitle>

      <div className='card card-stretch mb-5 mb-xxl-8'>
        <div className='card-body' style={{marginTop: '0.5em'}}>
          <div className='container' style={{padding: 0}}>
              {/* ÜrünAfiş start */}
              <div className='landing-poster'>
                {productModel?.documentRelations
                  .filter((x) => x.rank == 0 && x.document.documentTypeCode == 'F')
                  .map((x) => (
                    <div key={x.guid} style={{marginBottom: '5%'}}>
                      <img src={x.document.fileName} style={{width: '100%'}} />
                    </div>
                  ))}
              </div>
              {/* ÜrünAfiş end */}

              {/* ÜrünDetay start */}
              <div className='product-detail'>
                  <div className='product-images'>
                    <Slider {...settings}>
                      {productDetailImages?.map((x) => (
                        <div key={x.guid}>
                          <img
                            src={x.document.fileName + '?w=400&h=400&mode=pad'}
                            className='product-image'
                          />
                        </div>
                      ))}
                    </Slider>
                  </div>
                <div
                    className='product-info'
                 
                >
                  <h2>{productModel?.displayName}</h2>
                  <h4>{productModel?.shortDescription}</h4>

                  <h5 className='mt-5'>
                    <i>Ürün Etiketleri</i>
                  </h5>

                  <div>
                    {/* <span className="badge badge-primary">Etiket1</span> */}
                    <div className='search-landings'>
                      {productModel?.productTags
                        .sort((a: ProductTag, b: ProductTag) => (a.tagText > b.tagText ? 1 : -1))
                        .map((x) => (
                          <div className='landings'>
                            <a
                              title={x.tagText}
                              href={'productTag?ProductTag=' + x.tagText}
                              target='_blank' rel="noreferrer"
                            >
                              {x.tagText}
                            </a>
                          </div>
                        ))}
                    </div>
                  </div>

                  <div style={{marginTop: '10%'}}>
                    <p style={{wordWrap: 'break-word', textAlign: 'justify'}}>
                      {productModel?.detailedDescription}
                    </p>
                  </div>
                </div>
              </div>
              {/* ÜrünDetay end */}

            {/* Ürün Dokümanları Start */}
            <div className='mt-20'>
              {productDetailDocuments != undefined && productDetailDocuments.length > 0 ? (
                <>
                  <h4>Dokümanlar({productDetailDocuments.length})</h4>
                  <div style={styles.DocumentDiv}>
                    {productModel?.documentRelations
                      .filter((x) => x.document.documentTypeCode == 'D')
                      .sort((x: DocumentRelations, y: DocumentRelations) =>
                        x.rank - y.rank > 1 ? 1 : 0
                      )
                      .map((x) => (
                        <div key={x.guid} className='docs' >
                          <div className='d-flex flex-grow-1 bg-hover-light py-6 px-6 rounded overlay'>
                            <div
                              className='d-flex flex-grow-1 align-items-center overlay-wrapper'
                              style={{minWidth: '75px'}}
                            >
                              <div className='mr-4 flex-shrink-0 text-lef w-40px'>
                                <div className='symbol symbol-75px mb-6'>
                                  <img src={toAbsoluteUrl('/media/svg/files/pdf.svg')} alt='' />
                                </div>
                              </div>
                            </div>
                            <div className='overlay-layer overlay bg-gray-500 bg-opacity-25 rounded d-flex svg-icon'>
                              <a
                                href={x.document.fileName}
                                target={'_blank'}
                                className='btn btn-primary fw-bold py-2 px-4 fs-7 me-3'
                              >
                                Aç
                              </a>
                            </div>
                            <div style={{position: 'absolute', bottom: 0, left: '9%'}}>
                              <span>{subStrFunc(x.document.displayName, 11, '...')}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            {/* Ürün Dokümanları End*/}

            {/* Ürün Videoları Start */}
            <div className='mt-20'>
              {productVideos != undefined && productVideos.length > 0 ? (
                <>
                  <h4>Videolar({productVideos.length})</h4>
                  <div style={styles.DocumentDiv} className='mt-5'>
                    {productVideos
                      .sort((x: DocumentRelations, y: DocumentRelations) =>
                        x.rank - y.rank > 1 ? 1 : 0
                      )
                      .map((x) => (
                        <div className='mr-5 video' >
                          <div key={x.guid}>
                            <iframe src={x.document.fileName} allowFullScreen={true}></iframe>
                          </div>
                          <div style={{position: 'absolute', bottom: '-19%', left: '35%'}}>
                            {subStrFunc(x.document.displayName, 11, '...')}
                          </div>
                        </div>
                      ))}
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            {/* Ürün Videoları End */}
          </div>
        </div>
      </div>
    </>
  )
}

const styles = {
  DocumentDiv: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
}
